import React, { useCallback } from 'react';

import auth from '../utils/auth';

import Icon, { LogoutIcon } from '../utils/icons';

const Logout = () => {
  const handleLogout = useCallback(e => {
    e.preventDefault();

    auth.logout(() => {
      window.location.replace('/login');
    });
  }, []);

  return (
    <a className="nav-item" onClick={handleLogout}>
      <div className="nav-item-icon">
        <Icon size={18} icon={LogoutIcon} />
      </div>
      <div className="nav-item-title">Kirjaudu ulos</div>
    </a>
  );
};

export default Logout;
